import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaUsers } from "react-icons/fa";
import { MdFormatListBulleted } from "react-icons/md";
import CrmListPage from "components/app/crm/shared/CrmListPage";
import { columnDefs as baseColumns } from "./component/Columns";
import { getAllCustomers, exportCustomers } from "redux/crm/customerSlice";
import { getIndustries } from "redux/crm/settingSlice";
import { CRM_TYPE_OF_CUSTOMER, CRM_LEGAL_STATUS, CRM_KYC_CHECKLIST } from "app_config";

const SORTABLE = {
  customer_code: "id", name: "name", email: "email", telephone: "telephone",
  type_of_company: "type_of_company", legal_status: "legal_status", industry: "industry",
  kyc_type: "kyc_type", created_at: "created_at", updated_at: "updated_at"
};

const columns = baseColumns.map((c) =>
  SORTABLE[c.field] ? { ...c, colId: SORTABLE[c.field], sortable: true } : { ...c, sortable: false }
);

const toOptions = (arr) => arr.map((v) => ({ value: v, label: v }));

const TABS = [{ key: "all", label: "All", Icon: MdFormatListBulleted, thunk: getAllCustomers, dataKey: "allData" }];

const CustomerListPage = () => {
  const dispatch = useDispatch();
  const { industryData = [] } = useSelector((s) => s.crm_setting);

  useEffect(() => { if (industryData.length === 0) dispatch(getIndustries()); }, [dispatch, industryData.length]);

  const advancedFields = useMemo(() => [
    { key: "id",                label: "Customer ID#",     type: "text",        paramKey: "id_cont",              tagName: "ID#" },
    { key: "name",              label: "Customer name",    type: "text",        paramKey: "name_cont",            tagName: "Name" },
    { key: "email",             label: "Email",            type: "text",        paramKey: "email_cont",           tagName: "Email" },
    { key: "telephone",         label: "Telephone",        type: "text",        paramKey: "telephone_cont",       tagName: "Tel" },
    { key: "main_contact",      label: "Main contact",     type: "text",        paramKey: "main_contact_cont",    tagName: "Main" },
    { key: "secondary_contact", label: "Secondary contact", type: "text",       paramKey: "secondary_contact_in", tagName: "Secondary" },
    { key: "legal_status",      label: "Legal status",     type: "multiselect", options: toOptions(CRM_LEGAL_STATUS),    paramKey: "legal_status_in",    tagName: "Legal" },
    { key: "type_of_company",   label: "Type of customer", type: "multiselect", options: toOptions(CRM_TYPE_OF_CUSTOMER), paramKey: "type_of_company_in", tagName: "Type" },
    { key: "kyc_type",          label: "KYC",              type: "multiselect", options: toOptions(CRM_KYC_CHECKLIST),    paramKey: "kyc_type_in",        tagName: "KYC" },
    { key: "industry",          label: "Industry",         type: "multiselect", options: industryData.map((i) => ({ value: i.name, label: i.name })), paramKey: "industry_in", tagName: "Industry" }
  ], [industryData]);

  return (
    <CrmListPage
      title="Customers"
      subtitle="List of customers."
      Icon={FaUsers}
      reducerSelector={(s) => s.crm_customer}
      tabs={TABS}
      columns={columns}
      defaultSort={{ attribute: "id", direction: "DESC" }}
      searchParamKey="id_or_name_cont"
      searchPlaceholder="ID#, customer name..."
      dateFilters={[{ key: "created", label: "Created date", paramKeys: ["created_date_gteq", "created_date_lteq"], defaultThisMonth: true }]}
      showSalesUnit
      advancedFields={advancedFields}
      advancedTitle="Filters for customers"
      advancedDescription="Establish the customer's filtering criteria"
      exportThunk={exportCustomers}
    />
  );
};

export default CustomerListPage;
